// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @28.05.2021 13:27:20

import { CPatientBase_abstract } from './../abstract/SagaSchema/CPatientBase_abstract';

export class CPatientBase extends CPatientBase_abstract {}
